import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { NovaPortalLibConfig } from './nova-portal-lib-config.interface';
import { LIB_CONFIG } from './nova-portal-lib-config.token';

export const novaPortalLibProviders = (config: NovaPortalLibConfig): Provider[] => [
	{ provide: LIB_CONFIG, useValue: config }
];

/**
 * Provides NOVA Portal library configuration for standalone applications.
 * @param config Library configuration.
 * @returns Environment providers for the library configuration.
 */
export const provideNovaPortalLib = (config: NovaPortalLibConfig): EnvironmentProviders =>
	makeEnvironmentProviders(novaPortalLibProviders(config));
